import { take, fork, call, put } from 'redux-saga/effects';
import actionTypes from '../actionTypes';
import { successChangeAvatar, failureChangeAvatar } from "../actionCreators/profileSettings";
import { callApi } from "./callApi";
import config from '../../config/config';
import t from '../../config/translations';

export function* onLanguageChange() {
  while (true) {
    const action = yield take(actionTypes.LANGUAGE_CHANGE);
    t.setLanguage(action.value);
    localStorage.setItem('language', action.value);
  }
}
